module.exports = __webpack_public_path__ + "static/7-78bbc43417679c6c8b5ea3c2d72937ba.jpg";